import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./Location.html';
import styles from './Location-hashed.scss';

export default (function () {
    return {
        restrict: 'E',
        scope: {
            scheduledItem: '<'
        },
        template: cssUtil.hashTemplate(template, styles),
        controller: ['$scope', 'AddressUtil', function ($scope, AddressUtil) {
            $scope.$watch('scheduledItem.describe().location.address', function (address) {
                $scope.address = AddressUtil.format(address);
            });
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/subdirectives/list/Location/Location.js
// module id = 272
// module chunks = 0